import { Wrapper } from '@american-autonomy/ag-ui';

import { LIFECYCLE_CLASS_KEYS, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BatteryLifecyclePill: FunctionComponent<Props> = ({
    className = '',
    label,
    status,
    testId = TEST_ID
}) => {
    const lifecycleClass = styles[LIFECYCLE_CLASS_KEYS[status]] ?? '';

    return (
        <Wrapper
            className={`${styles.batteryLifecyclePill} ${lifecycleClass} ${className}`}
            testId={testId}>
            <Wrapper className={styles.dot} />

            {label}
        </Wrapper>
    );
};

export default BatteryLifecyclePill;
